import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export type ArrowDownProps = SvgIconProps & {
  /**
   * The circular background of the arrow
   */
  backgroundColor?: string;
};

export const ArrowUp = ({
  height = 24,
  width = 24,
  color = colors.green100,
  backgroundColor = colors.green10,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 -5.24537e-07C8.8174 -6.63652e-07 5.76515 1.26428 3.51472 3.51472C1.26428 5.76515 -2.29277e-06 8.8174 -2.43189e-06 12C-2.571e-06 15.1826 1.26428 18.2348 3.51472 20.4853C5.76515 22.7357 8.8174 24 12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 -3.85421e-07 12 -5.24537e-07Z"
      fill={getColor(backgroundColor, isColorInherited)}
      opacity={isColorInherited ? '0.1' : 1}
    />
    <path
      d="M16.5458 7.94359L15.7609 15.0062C15.7454 15.1466 15.6905 15.2798 15.6026 15.3905C15.5147 15.5011 15.3974 15.5847 15.2641 15.6315C15.1307 15.6784 14.9869 15.6866 14.8491 15.6553C14.7113 15.624 14.5852 15.5544 14.4852 15.4545L12.9367 13.9059L9.22437 17.6182C9.08371 17.7589 8.89295 17.8379 8.69404 17.8379C8.49512 17.8379 8.30436 17.7589 8.16371 17.6182L6.04239 15.4969C5.90173 15.3563 5.82272 15.1655 5.82272 14.9666C5.82272 14.7677 5.90173 14.5769 6.04239 14.4362L9.7547 10.7239L8.20613 9.17537C8.10625 9.07542 8.03664 8.94928 8.00531 8.81149C7.97399 8.6737 7.98223 8.52987 8.02908 8.39656C8.07593 8.26325 8.15949 8.14588 8.27013 8.05799C8.38077 7.97009 8.51399 7.91524 8.65444 7.89975L15.717 7.11486C15.8289 7.10254 15.942 7.1155 16.0482 7.15279C16.1543 7.19008 16.2507 7.25075 16.3303 7.33031C16.4099 7.40986 16.4705 7.50628 16.5078 7.61243C16.5451 7.71858 16.5581 7.83175 16.5458 7.94359V7.94359Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
